<template>
  <div class="tag-input">
    <!-- <input
      type="text"
      placeholder="Legg til interesse"
      class="tag-input__text"
      @keydown.enter="addTag"
      @keydown.188="addTag"
    /> -->
    <div class="tag-container">
      <div
        v-for="interest in userInfo.interests"
        :key="interest.id"
        class="tag"
      >
        <span @click="removeInterest(interest.id)">&#x2715;</span>
        {{ interest.name }}
      </div>
    </div>

    <div>
      Legg til:
      <select v-model="newInterestInputValue" @input="addInterest($event)">
        <option value="null" disabled selected>Legg til en interesse</option>
        <option
          v-for="interest in sortedInterests"
          :value="interest.id"
          v-bind:key="interest.id"
        >
          {{ interest.name }}
        </option>
      </select>
      <!-- <button @click="addInterest">Legg til</button> -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapActions } from "vuex";

export default {
  name: "ProfileInterest",
  data() {
    return {
      newInterestInputValue: null,
      allInterests: [],
    };
  },
  mounted() {
    this.getAllInterests();
  },
  computed: {
    ...mapState(["userInfo"]),

    sortedInterests() {
      let filtered = this.allInterests.filter((interest) => {
        if (
          this.$store.state.userInfo.interests.some(
            (theInterest) => theInterest.id === interest.id
          )
        ) {
          return false;
        }
        return true;
      });

      let sorted = filtered.sort((a, b) => {
        let fa = a.name.toLowerCase();
        let fb = b.name.toLowerCase();

        if (fa < fb) {
          return -1;
        }
        if (fa > fb) {
          return 1;
        }
        return 0;
      });

      return sorted;
    },
  },
  methods: {
    ...mapActions(["addUserInterests", "deleteUserInterests", "getToken"]),

    async getAllInterests() {
      await this.getToken();

      await axios
        .get(
          `${this.$store.state.baseApiUrl}/Interest`,
          this.$store.getters.axiosConfig
        )
        .then((response) => {
          this.allInterests = response.data;
        })
        .catch((error) => {
          console.log("Kunne ikke hente alle interessene: ", error);
        });
    },

    async addInterest(event) {
      let interestId = event.target.value;
      if (interestId === null) return;

      this.addUserInterests(interestId)
        .then(() => {
          this.newInterestInputValue = null;
        })
        .catch((error) => {
          this.newInterestInputValue = null;
          console.log("Kunne ikke legge til interesse hos brukeren: ", error);
        });
    },

    async removeInterest(projectId) {
      this.deleteUserInterests(projectId)
        .then(() => {})
        .catch((error) => {
          console.log("Kunne ikke legge til interesse hos brukeren: ", error);
        });
    },
  },
};
</script>

<style scoped lang="scss">
.tag-container {
  margin-bottom: 10px;
}

.tag {
  height: 30px;
  line-height: 30px;
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 10px;
  background-color: #eee;
  padding: 0 10px;
  border-radius: 15px;

  & > span {
    cursor: pointer;
    opacity: 0.4;
  }
}

select {
  margin-right: 5px;
  cursor: pointer;
}
</style>